import React, { useContext, createContext, useEffect } from 'react'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import PropTypes from 'prop-types'
import { __prod__ } from 'settings/app/constants'

export const HeaderContext_ = createContext({})

export const HeaderProvider = ({ children }) => {
  const textContext = useContext(TextContext)

  const [headerState, setHeaderState] = React.useState({
    headerImage: '',
    headerTitle: '',
    textTitle: '',
    text: '',
  })

  useEffect(() => {
    const entryPoint = localStorage.getItem('entryPoint')
    let headerImage, headerTitle, text, textTitle

    if (__prod__) {
      headerTitle = localStorage.getItem('headerTitle')
      headerImage = localStorage.getItem('headerImage')
      text = localStorage.getItem('text')
      textTitle = localStorage.getItem('textTitle')
    } else {
      headerTitle = textContext[`search.title.${ entryPoint }`]
      headerImage = '../../assets/ExampleHeaderImage.jpg'
      text =
        'Der AOK-Gesundheitsnavigator hilft Ihnen bei der Suche nach einem passenden Arzt, Zahnarzt, Psychotherapeuten, Krankenhaus oder einer Hebamme. Sie können nach verschiedenen Kriterien suchen und erhalten in der Ergebnisliste umfangreiche Informationen zu den jeweiligen Angeboten.'
      textTitle =
        '/ Suche' !== headerTitle ? headerTitle : 'Krankenhaussuche (default)'
    }

    setHeaderState({
      headerTitle,
      headerImage,
      textTitle,
      text,
    })
  }, [textContext])

  return (
    <HeaderContext_.Provider value={ headerState }>
      {children}
    </HeaderContext_.Provider>
  )
}

HeaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const HeaderConsumer_ = HeaderContext_.Consumer

export default HeaderProvider
